import '../global';
class Hdrs {
    constructor(init) {
        if (!new.target) {
            throw new TypeError(`Class constructor 'Headers' cannot be invoked without 'new'`);
        }
        return new Headers(init);
    }
}
const klass = Hdrs;
export {
    klass as Headers
};
export default klass;    //# sourceMappingURL=Headers.js.map
